export default {"src":"/_next/static/media/compliance-and-privacy.f1a8ddf0.svg","height":512,"width":384,"blurWidth":0,"blurHeight":0};